import React, { useEffect, useState } from "react";
import phone1 from "../assets/logos/projects/phone1.png";
import phone2 from "../assets/logos/projects/phone2.png";
import phone3 from "../assets/logos/projects/phone3.png";
import tablet1 from "../assets/logos/projects/ipad1.png";
import tablet2 from "../assets/logos/projects/ipad2.png";
import tablet3 from "../assets/logos/projects/ipad3.png";
import laptop1 from "../assets/logos/projects/monitor1.png";
import laptop2 from "../assets/logos/projects/monitor2.png";
import laptop3 from "../assets/logos/projects/monitor3.png";
import monitor1 from "../assets/logos/projects/monitor1.png";
import monitor2 from "../assets/logos/projects/monitor2.png";
import monitor3 from "../assets/logos/projects/monitor3.png";


const DeviceShowcase = () => {
    // Project images array (same index images will show together)
    const projects = [
        {
            phone: phone1,
            tablet: tablet1,
            laptop: laptop1,
            monitor: monitor1,
        },
        {
            phone: phone2,
            tablet: tablet2,
            laptop: laptop2,
            monitor: monitor2,
        },
        {
            phone: phone3,
            tablet: tablet3,
            laptop: laptop3,
            monitor: monitor3,
        },
        // Add more projects if needed
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % projects.length);
        }, 4000); // change every 4 seconds

        return () => clearInterval(interval);
    }, [projects.length]);

    const current = projects[currentIndex];

    return (
        <div className="bg-black text-white py-16 px-6 flex flex-col items-center">
            <h2 className="text-2xl sm:text-3xl font-bold mb-10 text-[#f6f4d2] text-center">
                Project Preview on Different Devices
            </h2>

            {/* First Row: Phone + Monitor */}
            <div className="w-full xyz1 flex flex-wrap justify-center items-center gap-8 mb-10">
                {/* Phone */}
                <div className="flex flex-col items-center">
                    <div className="w-[210px] h-[440px] bg-[#1a1a1a] rounded-[1rem] border-[6px] border-gray-400 shadow-lg relative flex items-center justify-center overflow-hidden">
                        <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-10 h-1 rounded bg-gray-500" />
                        <div className="w-[90%] h-[92%] rounded-md overflow-hidden bg-black">
                            <img src={current.phone} alt="Phone" className="w-full h-full object-cover" />
                        </div>
                    </div>
                    <p className="mt-3 text-sm text-gray-300 font-semibold">Phone</p>
                </div>

                {/* Monitor */}
                <div className="flex flex-col items-center">
                    <div className="w-[420px] h-[240px] bg-[#1a1a1a] border-[6px] border-gray-700 shadow-2xl rounded-md relative flex items-center justify-center overflow-hidden">
                        <div className="absolute bottom-[-20px] left-1/2 transform -translate-x-1/2 w-10 h-4 bg-gray-500 rounded" />
                        <div className="w-[94%] h-[92%] rounded-sm overflow-hidden bg-black">
                            <img src={current.monitor} alt="Monitor" className="w-full h-full object-cover" />
                        </div>
                    </div>
                    <p className="mt-3 text-sm text-gray-300 font-semibold">Monitor</p>
                </div>
            </div>

            {/* Second Row: Tablet + Laptop */}
            <div className="w-full xyz1 flex flex-wrap justify-center items-center gap-8">
                {/* Tablet */}
                <div className="flex flex-col items-center">
                    <div className="w-[300px] h-[400px] bg-[#1a1a1a] rounded-2xl border-[8px] border-gray-500 shadow-xl relative flex items-center justify-center overflow-hidden">
                        <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-12 h-1 rounded bg-gray-400" />
                        <div className="w-[93%] h-[91%] rounded-md overflow-hidden bg-black">
                            <img src={current.tablet} alt="Tablet" className="w-full h-full object-cover" />
                        </div>
                    </div>
                    <p className="mt-3 text-sm text-gray-300 font-semibold">Tablet</p>
                </div>

                {/* Laptop */}
                <div className="flex flex-col items-center">
                    <div className="w-[400px] h-[220px] bg-[#1a1a1a] rounded-xl border-[6px] border-gray-600 shadow-2xl relative flex items-center justify-center overflow-hidden">
                        <div className="absolute bottom-[-12px] left-1/2 transform -translate-x-1/2 w-16 h-2 bg-gray-500 rounded-b" />
                        <div className="w-[94%] h-[90%] rounded-sm overflow-hidden bg-black">
                            <img src={current.laptop} alt="Laptop" className="w-full h-full object-cover" />
                        </div>
                    </div>
                    <p className="mt-3 text-sm text-gray-300 font-semibold">Laptop</p>
                </div>
            </div>
        </div>
    );
};

export default DeviceShowcase;
